
const CloseIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
            <g clipPath="url(#clip0_1530_1024)">
                <path d="M8.99956 7.93949L12.7121 4.22699L13.7726 5.28749L10.0601 8.99999L13.7726 12.7125L12.7121 13.773L8.99956 10.0605L5.28706 13.773L4.22656 12.7125L7.93906 8.99999L4.22656 5.28749L5.28706 4.22699L8.99956 7.93949Z" fill="#667085" />
            </g>
            <defs>
                <clipPath id="clip0_1530_1024">
                    <rect width="18" height="18" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}

export default CloseIcon